import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import { FaEye } from "react-icons/fa";

export default ({ item, key }: any) => {
  return (
    <div
      key={key}
      className="group relative p-2 bg-white border border-slate-100 rounded-xl w-[200px] overflow-hidden shadow-xs hover:shadow-md hover:border-slate-200 transition-all duration-300"
    >
      {/* Card Aspect Ratio Frame Wrapper */}
      <div className="h-[180px] w-full rounded-lg overflow-hidden bg-slate-50 relative">
        <LazyLoadImage
          src={item.uri}
          alt="Dashboard snapshot capture feed"
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
          effect="blur"
          wrapperProps={{
            style: { transitionDelay: "0.3s", width: "100%", height: "100%" },
          }}
        />

        {/* Glossy Overlay visible on card group hover matching the system pattern */}
        <div className="absolute inset-0 bg-[#012063]/40 opacity-0 group-hover:opacity-100 transition-opacity duration-200 flex items-center justify-center backdrop-blur-xs">
          <span className="p-2.5 bg-white/20 backdrop-blur-md rounded-full text-white text-xs border border-white/20 shadow-sm transform scale-90 group-hover:scale-100 transition-transform duration-300">
            <FaEye className="text-sm" />
          </span>
        </div>
      </div>

      {/* Conditional Subtext Meta Label if the model provides properties */}
      {item.created_at && (
        <div className="pt-2 px-1 text-left">
          <p className="text-[10px] font-mono font-bold text-slate-400">
            {new Date(item.created_at).toLocaleDateString(undefined, {
              month: "short",
              day: "numeric",
            })}
          </p>
        </div>
      )}
    </div>
  );
};
